import { combineReducers } from "redux";
import {
  createWorkActivitiesReducer,
  updateWorkActivityReducer,
  fetchWorkActivitiesReducer,
  updateWorkActivityModalStatusReducer,
  editWorkActivityReducer,
  newWorkActivityReducer,
  deleteWorkActivityReducer,
} from "./WorkActivities/WorkActivitiesReducer";

import {
  createCoursesReducer,
  updateCourseReducer,
  fetchCoursesReducer,
  updateCourseModalStatusReducer,
  editCourseReducer,
  newCourseReducer,
  deleteCourseReducer,
} from "./Courses/CoursesReducer";

import {
  createMcatScoresReducer,
  updateMcatScoreReducer,
  fetchMcatScoresReducer,
  updateMcatScoreModalStatusReducer,
  editMcatScoreReducer,
  newMcatScoreReducer,
  deleteMcatScoreReducer,
} from "./McatScores/McatScoresReducer";

import {
  loginAuthReducer,
  adminUserReducer,
  renewTokenReducer,
} from "./UserAuthentication/LoginReducer";

import { fetchGradeReducer } from "./Grades/GradesReducer";

import { signupUserReducer } from "./UserAuthentication/RegisterReducer";
import {
  updateForgotPasswordModalStatusReducer,
  forgotPasswordReducer,
} from "./UserAuthentication/ForgotPasswordReducer";
import { resetPasswordReducer } from "./UserAuthentication/ResetPasswordReducer";

import {
  personalStatementReducer,
  fetchPersonalStatementReducer,
} from "./PersonalStatement/PersonalStatementReducer";

import { fetchSchoolSearchReducer } from "./SchoolSearch/SchoolSearchReducer";

import {
  createSelectSchoolForSecondaryEssaysReducer,
  fetchSelectSchoolForSecondaryEssaysReducer,
  fetchResponseForSecondaryEssaysReducer,
  createAnswersForSecondaryEssaysReducer,
  deleteSelectedSchoolForSecondaryEssayReducer,
  deleteResponseForSecondaryEssayReducer,
  updateSecondaryStatusReducer,
} from "./SecondaryEssays/SecondaryEssaysReducer";

import {
  createProfilePictureReducer,
  updateUserProfileReducer,
  fetchUniversitiesReducer,
  getUserDetailsReducer,
  updateUserPhoneNumberReducer,
  updateUserCommunitySettingsReducer,
} from "./Users/UsersReducer";
import { fetchSSOTokenReducer } from "./Ideas/IdeasReducer";
import {
  fetchAllUsersReducer,
  fetchUserDetailsReducer,
  updateUserDetailsReducer,
  updateMultiUsersReducer,
  adminCreateUserReducer,
} from "./ManageUsers/ManageUsersReducer";
// import { fetchAllUsersDataReducer } from "./ManageUsersApi/ManageUsersReducer";
import {
  createCustomerReducer,
  createSubscriptionReducer,
  updateSubscriptionReducer,
  cancelSubscriptionReducer,
  manageSubscriptionModalStatusReducer,
  resumeSubscriptionReducer,
  fetchDetailsSubscriptionReducer,
  buyTutoringHoursModalStatusReducer,
  createTutoringHoursPaymentReducer,
  createTpcCoursePaymentReducer,
  fetchPaymentRecordReducer,
  updateTutoringHoursAvailableReducer,
  createAccessPaymentReducer,
  confirmAccessPaymentReducer,
} from "./Payments/PaymentsReducer";
import { createReportedIssueReducer } from "./Support/SupportReducer";
import {
  createCoachTutorAvailabilityReducer,
  fetchCoachTutorAvailabilityReducer,
  fetchHistoryCoachTutorAvailabilityReducer,
  deleteCoachTutorAvailabilityReducer,
} from "./ManageCoachTutorAvailability/ManageCoachTutorAvailabilityReducer";

import {
  fetchAvailableScheduleReducer,
  fetchScheduleReducer,
  createRequestTutorReducer,
  createRequestSchedTutorReducer,
  fetchRequestTutorReducer,
  fetchStudentScheduleReducer,
  cancelRequestTutorReducer,
  fetchRequestTutorHistoryReducer,
  fetchCoachesReducer,
} from "./ScheduleTutor/ScheduleTutorReducer";

import {
  fetchStudentRequestTutorReducer,
  approveStudentRequestTutorReducer,
  disapproveStudentRequestTutorReducer,
  fetchStudentRequestTutorHistoryReducer,
  updateModalUploadTutorVideoFileStatusReducer,
  editTutorRequestReducer,
  createStrUploadReducer,
  getVimeoLinkReducer
} from "./ManageTutorRequests/ManageTutorRequestsReducer";

import {
  createProMemberPostReducer,
  updateCommunityProMemberPostReducer,
  deleteCommunityProMemberPostReducer,
  createCommunityProMemberCommentReducer,
  updateCommunityProMemberCommentReducer,
  deleteCommunityProMemberCommentReducer,
  createCommunityProMemberReplyReducer,
  updateCommunityProMemberReplyReducer,
  deleteCommunityProMemberReplyReducer,
} from "./Community/ProMemberReducer";

import {
  createUasPostReducer, 
  updateCommunityUasPostReducer,
  deleteCommunityUasPostReducer,
  createCommunityUasCommentReducer,
  updateCommunityUasCommentReducer,
  deleteCommunityUasCommentReducer,
  createCommunityUasReplyReducer,
  updateCommunityUasReplyReducer,
  deleteCommunityUasReplyReducer,} from "./Community/UasReducer"

import {
  fetchAllCommunityPostsReducer,
  createCommunityPostReducer,
  updateCommunityPostReducer,
  deleteCommunityPostReducer,
  createCommunityCommentReducer,
  updateCommunityCommentReducer,
  deleteCommunityCommentReducer,
  createCommunityReplyReducer,
  updateCommunityReplyReducer,
  deleteCommunityReplyReducer,
  fetchCommunityLikedPostReducer,
  fetchLeaderboardReducer,
} from "./Community/CommunityReducer";

import {
  createTpcCourseReducer,
  updateTpcCourseReducer,
  fetchTpcCoursesReducer,
  deleteTpcCourseReducer,
  createTpcCourseCategoryReducer,
  createTpcCourseLessonsReducer,
  updateTpcCourseCategoryOrderReducer,
  updateTpcCourseCategoryReducer,
  updateTpcCourseLessonsReducer,
  deleteTpcCourseLessonsReducer,
  deleteTpcCourseCategoryReducer,
  updateMarkedCompleteLessonReducer,
  fetchMarkedCompleteLessonReducer,
  createBundleCoursesReducer,
  fetchBundleCoursesReducer,
  saveCoursesOrderReducer,
  searchTpcCoursesReducer,
  fetchLessonTranscriptReducer
} from "./ManageTpcCourses/ManageTpcCoursesReducer";

import { fetchAppHourUsedLogsReducer, fetchAppLogReducer,fetchPremiumHourLogsReducer, sendEmailApplicationHourUsedReducer } from "./Logs/LogsReducer";

import {sendEmailNotificationReducer} from "./Community/EmailReducer";
import {createTimelineScheduleReducer} from "./Timeline/TimelineReducer";
import {fetchTimelineScheduleReducer} from "./Timeline/TimelineReducer";


import { createStudentToLifetimePlanReducer, fetchLtpItemReducer, deleteLtpItemReducer } from "./ManageLifeTimePlan/ManageLifeTimePlanReducer";


import { messagesReducer } from "./Messages/MessagesReducer"
import { presenceReducer } from "./Messages/PresenceReducer";
import { threadsReducer } from "./Messages/ThreadsReducer";
import { usersPreptalkReducer } from "./Messages/UsersPrepTalkReducer";

import activeThreadReducer from "./Messages/ActiveThreadReducer";

import { smsReducer } from "redux/ManageTextSequence/ManageTextSequenceReducer";

import { automationReducer } from "./Messages/AutomationReducer";

import dataMetricsReducer from "./DataMetrics/DataMetricsReducer";
import { fetchMyStudentsReducer, fetchCoachAppHoursReducer, fetchTotalLogSessionsOfStudentsReducer } from "./CoachAnalytics/CoachAnalyticsReducer";
import { createApplicationHoursStatsPerMonthReducer } from "./ManageAnalytics/ManageAnalyticsReducer";
import {fetchApplicationHoursStatsPerMonthReducer} from "./ApplicationHoursAnalytics/ApplicationHoursAnalyticsReducer";

// Admin Coach Application Hours Analytics
import { coachAppHoursAnalyticsReducer } from "./CoachApplicationHoursAnalytics/CoachAppHoursAnalyticsReducer";

import { subjectsReducer, unitsReducer, topicsReducer } from "./QuestionBank/SubjectsUnitsReducer";
import { questionsReducer } from "./QuestionBank/QuestionsReducer";
import aiGenerationReducer from "./QuestionBank/AIGenerationReducer";
import { passageReducer } from "./QuestionBank/PassageReducer";
import { testProgressReducer } from "./QuestionBank/TestProgressReducer";
import { feedbackReducer } from "./QuestionBank/FeedbackReducer";
import adminAnalyticsReducer from "./QuestionBank/AdminAnalyticsReducer";
import fullLengthExamReducer from "./QuestionBank/FullLengthExamReducer";
import uploadLogsReducer from "./QuestionBank/UploadLogsReducer";
import trialReducer from "./Trial/TrialReducer";
import {
  createGroupOrderReducer,
  fetchGroupOrdersReducer,
  fetchGroupOrderDetailsReducer,
  fetchGroupOrderReducer,
  createGroupPaymentReducer,
  confirmGroupPaymentReducer,
  fetchMyGroupOrdersReducer,
  redeemGroupCodeReducer,
  validateGroupCodeReducer,
  createIndividualCodePaymentReducer,
  confirmIndividualCodePaymentReducer,
  createIndividualCodePaymentPublicReducer,
  activatePaidCodesReducer,
  approveGroupOrderRequestReducer,
  rejectGroupOrderRequestReducer,
} from "./GroupOrders/GroupOrdersReducer";

import {
  listPaymentMethodsReducer,
  billingActionsReducer,
} from "./Billing/BillingReducer";

import specialtyReducer from "./Specialty/SpecialtyReducer";
import { resourceFilesReducer } from "./ResourceFiles/ResourceFilesReducer";

const rootReducer = combineReducers({
  createWorkActivities: createWorkActivitiesReducer,
  updateWorkActivities: updateWorkActivityReducer,
  fetchWorkActivities: fetchWorkActivitiesReducer,
  updateWorkActivityModalStatus: updateWorkActivityModalStatusReducer,
  editWorkActivity: editWorkActivityReducer,
  newWorkActivity: newWorkActivityReducer,
  deleteWorkActivity: deleteWorkActivityReducer,

  createCourses: createCoursesReducer,
  updateCourses: updateCourseReducer,
  fetchCourses: fetchCoursesReducer,
  updateCourseModalStatus: updateCourseModalStatusReducer,
  editCourse: editCourseReducer,
  newCourse: newCourseReducer,
  deleteCourse: deleteCourseReducer,

  createMcatScores: createMcatScoresReducer,
  updateMcatScores: updateMcatScoreReducer,
  fetchMcatScores: fetchMcatScoresReducer,
  updateMcatScoreModalStatus: updateMcatScoreModalStatusReducer,
  editMcatScore: editMcatScoreReducer,
  newMcatScore: newMcatScoreReducer,
  deleteMcatScore: deleteMcatScoreReducer,

  loginAuth: loginAuthReducer,
  fetchGrade: fetchGradeReducer,
  signupUser: signupUserReducer,

  updateForgotPasswordModalStatus: updateForgotPasswordModalStatusReducer,
  forgotPassword: forgotPasswordReducer,

  resetPassword: resetPasswordReducer,
  personalStatement: personalStatementReducer,
  fetchPersonalStatement: fetchPersonalStatementReducer,

  fetchSchoolSearch: fetchSchoolSearchReducer,

  createSelectSchoolForSecondaryEssays:
    createSelectSchoolForSecondaryEssaysReducer,
  fetchSelectSchoolForSecondaryEssays:
    fetchSelectSchoolForSecondaryEssaysReducer,
  fetchResponseForSecondaryEssays: fetchResponseForSecondaryEssaysReducer,
  createAnswersForSecondaryEssays: createAnswersForSecondaryEssaysReducer,
  deleteSelectedSchoolForSecondaryEssay:
    deleteSelectedSchoolForSecondaryEssayReducer,
  deleteResponseForSecondaryEssay: deleteResponseForSecondaryEssayReducer,
  updateSecondaryStatus: updateSecondaryStatusReducer,

  createProfilePicture: createProfilePictureReducer,
  updateUserProfile: updateUserProfileReducer,
  updateUserCommunitySettings: updateUserCommunitySettingsReducer,
  fetchUniversities: fetchUniversitiesReducer,
  fetchSSOToken: fetchSSOTokenReducer,
  fetchAllUsers: fetchAllUsersReducer,
  fetchUserDetails: fetchUserDetailsReducer,
  updateUserDetails: updateUserDetailsReducer,
  updateMultiUsers: updateMultiUsersReducer,
  adminCreateUser: adminCreateUserReducer,
  createCustomer: createCustomerReducer,
  createSubscription: createSubscriptionReducer,
  updateSubscription: updateSubscriptionReducer,
  cancelSubscription: cancelSubscriptionReducer,
  manageSubscriptionModalStatus: manageSubscriptionModalStatusReducer,
  resumeSubscription: resumeSubscriptionReducer,
  fetchDetailsSubscription: fetchDetailsSubscriptionReducer,
  buyTutoringHoursModalStatus: buyTutoringHoursModalStatusReducer,
  createTutoringHoursPayment: createTutoringHoursPaymentReducer,
  createTpcCoursePayment: createTpcCoursePaymentReducer,
  fetchPaymentRecord: fetchPaymentRecordReducer,
  updateTutoringHoursAvailable: updateTutoringHoursAvailableReducer,
  createAccessPayment: createAccessPaymentReducer,
  confirmAccessPayment: confirmAccessPaymentReducer,
  createReportedIssue: createReportedIssueReducer,
  adminUser: adminUserReducer,
  renewToken: renewTokenReducer,

  updateUserPhoneNumber: updateUserPhoneNumberReducer,
  getUserDetails: getUserDetailsReducer,
  createCoachTutorAvailability: createCoachTutorAvailabilityReducer,
  fetchCoachTutorAvailability: fetchCoachTutorAvailabilityReducer,
  fetchHistoryCoachTutorAvailability: fetchHistoryCoachTutorAvailabilityReducer,
  deleteCoachTutorAvailability: deleteCoachTutorAvailabilityReducer,

  fetchAvailableSchedule: fetchAvailableScheduleReducer,
  fetchSchedule : fetchScheduleReducer,
  createRequestTutor: createRequestTutorReducer,
  createRequestSchedTutor: createRequestSchedTutorReducer,
  fetchRequestTutor: fetchRequestTutorReducer,
  fetchStudentSchedule: fetchStudentScheduleReducer,
  cancelRequestTutor: cancelRequestTutorReducer,
  fetchStudentRequestTutor: fetchStudentRequestTutorReducer,
  approveStudentRequestTutor: approveStudentRequestTutorReducer,
  disapproveStudentRequestTutor: disapproveStudentRequestTutorReducer,
  fetchRequestTutorHistory: fetchRequestTutorHistoryReducer,
  fetchStudentRequestTutorHistory: fetchStudentRequestTutorHistoryReducer,
  updateModalUploadTutorVideoFileStatus:
    updateModalUploadTutorVideoFileStatusReducer,
  editTutorRequest: editTutorRequestReducer,
  createStrUpload: createStrUploadReducer,
  getVimeoLink: getVimeoLinkReducer,

  fetchAllCommunityPosts: fetchAllCommunityPostsReducer,
  createCommunityPost: createCommunityPostReducer,
  updateCommunityPost: updateCommunityPostReducer,
  deleteCommunityPost: deleteCommunityPostReducer,
  createCommunityComment: createCommunityCommentReducer,
  updateCommunityComment: updateCommunityCommentReducer,
  deleteCommunityComment: deleteCommunityCommentReducer,
  createCommunityReply: createCommunityReplyReducer,
  updateCommunityReply: updateCommunityReplyReducer,
  deleteCommunityReply: deleteCommunityReplyReducer,
  fetchCommunityLikedPost: fetchCommunityLikedPostReducer,
  fetchLeaderboard: fetchLeaderboardReducer,

  createProMemberPost: createProMemberPostReducer,
  updateCommunityProMemberPost: updateCommunityProMemberPostReducer,
  deleteCommunityProMemberPost: deleteCommunityProMemberPostReducer,
  createCommunityProMemberComment: createCommunityProMemberCommentReducer,
  updateCommunityProMemberComment: updateCommunityProMemberCommentReducer,
  deleteCommunityProMemberComment: deleteCommunityProMemberCommentReducer,
  createCommunityProMemberReply: createCommunityProMemberReplyReducer,
  updateCommunityProMemberReply: updateCommunityProMemberReplyReducer,
  deleteCommunityProMemberReply: deleteCommunityProMemberReplyReducer,
  fetchCoaches: fetchCoachesReducer,

  createCommunityUasPost: createUasPostReducer,
  updateCommunityUasPost: updateCommunityUasPostReducer,
  deleteCommunityUasPost: deleteCommunityUasPostReducer,
  createCommunityUasComment: createCommunityUasCommentReducer,
  updateCommunityUasComment: updateCommunityUasCommentReducer,
  deleteCommunityUasComment: deleteCommunityUasCommentReducer,
  createCommunityUasReply: createCommunityUasReplyReducer,
  updateCommunityUasReply: updateCommunityUasReplyReducer,
  deleteCommunityUasReply: deleteCommunityUasReplyReducer,

  createTpcCourse: createTpcCourseReducer,
  updateTpcCourse: updateTpcCourseReducer,
  fetchTpcCourses: fetchTpcCoursesReducer,
  deleteTpcCourse: deleteTpcCourseReducer,
  createTpcCourseCategory: createTpcCourseCategoryReducer,
  createTpcCourseLessons: createTpcCourseLessonsReducer,
  updateTpcCourseCategoryOrder: updateTpcCourseCategoryOrderReducer,
  updateTpcCourseCategory: updateTpcCourseCategoryReducer,
  updateTpcCourseLessons: updateTpcCourseLessonsReducer,
  deleteTpcCourseLessons: deleteTpcCourseLessonsReducer,
  deleteTpcCourseCategory: deleteTpcCourseCategoryReducer,
  createBundleCourses: createBundleCoursesReducer,
  fetchBundleCourses:fetchBundleCoursesReducer,
  saveCoursesOrder: saveCoursesOrderReducer,
  searchTpcCourses: searchTpcCoursesReducer,
  updateMarkedCompleteLesson : updateMarkedCompleteLessonReducer,
  fetchMarkedCompleteLesson : fetchMarkedCompleteLessonReducer,
  fetchLessonTranscript: fetchLessonTranscriptReducer,

  fetchAppHourUsedLogs: fetchAppHourUsedLogsReducer,
  fetchAppLog: fetchAppLogReducer,
  fetchPremiumHourLogs:fetchPremiumHourLogsReducer,
  sendEmailApplicationHourUsed: sendEmailApplicationHourUsedReducer,
  sendEmailNotification: sendEmailApplicationHourUsedReducer,

  createTimelineSchedule : createTimelineScheduleReducer,
  fetchTimelineSchedule : fetchTimelineScheduleReducer,

  createStudentToLifetimePlan: createStudentToLifetimePlanReducer,
  fetchLtpItem: fetchLtpItemReducer,
  deleteLtpItem: deleteLtpItemReducer,

  messages : messagesReducer,
  presence : presenceReducer,
  threads : threadsReducer,
  usersPreptalk: usersPreptalkReducer,

  activeThread : activeThreadReducer,

  sms : smsReducer,

  automation: automationReducer,

  dataMetrics: dataMetricsReducer,

  createApplicationHoursStatsPerMonth: createApplicationHoursStatsPerMonthReducer,
  fetchApplicationHoursStatsPerMonth: fetchApplicationHoursStatsPerMonthReducer,

  fetchMyStudents: fetchMyStudentsReducer,

  fetchCoachAppHours: fetchCoachAppHoursReducer,

  fetchTotalLogSessionsOfStudents: fetchTotalLogSessionsOfStudentsReducer,

  // Question Bank
  questionBankSubjects: subjectsReducer,
  questionBankUnits: unitsReducer,
  questionBankQuestions: questionsReducer,
  aiGeneration: aiGenerationReducer,
  questionBankPassages: passageReducer,
  testProgress: testProgressReducer,
  questionBankTopics: topicsReducer,
  questionBankFeedback: feedbackReducer,
  adminAnalytics: adminAnalyticsReducer,
  fullLengthExams: fullLengthExamReducer,
  uploadLogs: uploadLogsReducer,
  //Manage User Api
  // fetchAllUsersData: fetchAllUsersDataReducer,

  coachAppHoursAnalyticsReducer: coachAppHoursAnalyticsReducer,

  // Trial
  trial: trialReducer,

  // Group Orders
  createGroupOrder: createGroupOrderReducer,
  fetchGroupOrders: fetchGroupOrdersReducer,
  fetchGroupOrderDetails: fetchGroupOrderDetailsReducer,
  fetchGroupOrder: fetchGroupOrderReducer,
  createGroupPayment: createGroupPaymentReducer,
  confirmGroupPayment: confirmGroupPaymentReducer,
  fetchMyGroupOrders: fetchMyGroupOrdersReducer,
  redeemGroupCode: redeemGroupCodeReducer,
  validateGroupCode: validateGroupCodeReducer,
  createIndividualCodePayment: createIndividualCodePaymentReducer,
  confirmIndividualCodePayment: confirmIndividualCodePaymentReducer,
  createIndividualCodePaymentPublic: createIndividualCodePaymentPublicReducer,
  activatePaidCodes: activatePaidCodesReducer,
  approveGroupOrderRequest: approveGroupOrderRequestReducer,
  rejectGroupOrderRequest: rejectGroupOrderRequestReducer,

  // Billing
  paymentMethods: listPaymentMethodsReducer,
  billingActions: billingActionsReducer,

  // Resource Files
  resourceFiles: resourceFilesReducer,

  // Specialty
  specialty: specialtyReducer,
});

export default rootReducer;
